module.exports = __webpack_public_path__ + "img/logo-paloma-small.13ff6ab8.png";